import {
  onboardHost,
  onboardProperty,
  viewHostDashboard,
  viewPropertyDashboard,
} from '@go-client/lib/api/stripe';
import React, { useState } from 'react';
import { BubbleButton, BubbleOverlay } from './BubbleUI';

interface StripeOnboardingProps {
  identifier: string;
  mode: 'host' | 'property';
  stripeAccountId: string | undefined;
  hasCompletedOnboarding: boolean;
}

export default function StripeOnboarding(props: StripeOnboardingProps) {
  const { identifier, mode, stripeAccountId, hasCompletedOnboarding } = props;
  const [stripeLoading, setStripeLoading] = useState(false);

  async function openOnboardLink() {
    setStripeLoading(true);
    try {
      const fnToUse = mode === 'host' ? onboardHost : onboardProperty;
      const resp = await fnToUse(identifier, window.location.href);
      window.location.href = resp.url;
    } finally {
      setStripeLoading(false);
    }
  }

  async function openDashboard() {
    setStripeLoading(true);
    try {
      const fnToUse = mode === 'host' ? viewHostDashboard : viewPropertyDashboard;
      const resp = await fnToUse(identifier);
      const a = document.createElement('a');
      a.href = resp.url;
      a.target = '_blank';
      a.click();
    } finally {
      setStripeLoading(false);
    }
  }

  return (
    <fieldset className="bg-white p-4 border rounded shadow grid grid-cols-1 gap-4 justify-items-start">
      {hasCompletedOnboarding ? (
        <div>
          <div className="mb-4">
            <strong>Account ID:</strong> {stripeAccountId}
          </div>
          <BubbleButton variant="stripe" onClick={openDashboard}>
            View Stripe Dashboard
          </BubbleButton>
        </div>
      ) : (
        <div>
          <div className="mb-4">
            In order to host events and receive payouts, you must{' '}
            <strong>complete the onboarding process</strong> with Stripe.
          </div>
          <BubbleOverlay loading={stripeLoading} className="inline-block">
            <BubbleButton variant="stripe" onClick={openOnboardLink}>
              Onboard with Stripe
            </BubbleButton>
          </BubbleOverlay>
        </div>
      )}
    </fieldset>
  );
}
